import type { ApolloError } from "@apollo/client";

export const formatEnumLabel = (value: string): string =>
  value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

/** Messages from a GraphQL execution result when present (e.g. partial mutation response). */
export const formatGqlExecutionErrors = (result: unknown): string | undefined => {
  if (!result || typeof result !== "object" || !("errors" in result)) {
    return undefined;
  }
  const errors = (result as { errors?: ReadonlyArray<{ message?: string }> }).errors;
  const msgs = errors?.map((err) => err.message).filter((m): m is string => Boolean(m?.trim()));
  if (!msgs?.length) {
    return undefined;
  }
  return msgs.join(" ");
};

/** Prefer GraphQL `errors[].message` from the server; then Error.message; then fallback. */
export const graphqlClientErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === "object") {
    const gqlErrs = (error as ApolloError).graphQLErrors;
    if (!gqlErrs?.length) {
      return fallback;
    }

    const msgs = gqlErrs.map((e) => e.message).filter((m): m is string => Boolean(m?.trim()));
    if (msgs.length > 0) {
      return msgs.join(" ");
    }
  }
  if (error instanceof Error) {
    const msg = error.message.trim();
    if (msg) {
      return msg;
    }
  }

  return fallback;
};
